module.exports = "/static/media/responsive-icon-white.f1bd8436.png";